<template>
  <div>
    <div class="search-container">
      <div class="field has-addons">
        <div v-if="query" class="control">
          <a class="button is-inverted" @click.stop="query = ''">
            <span class="icon is-right">
              <i class="fas fa-times" aria-hidden="true"></i>
            </span>
          </a>
        </div>
        <div
          style="width: 100%;"
          class="control"
          :class="{
            'is-loading': fetchingContent,
            'has-icons-left': !query
          }"
        >
          <input
            v-model="query"
            class="input"
            type="text"
            placeholder="Search folders and documents..."
          />
          <span v-if="!query" class="icon is-left">
            <i class="fas fa-search" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from '@/utils/general';
import { mapActions, mapState } from 'vuex';
export default {
  props: ['includeShared'],
  data() {
    return {
      query: ``
    };
  },
  computed: mapState(`content`, [`fetchingContent`]),
  watch: {
    query: debounce(function(query) {
      try {
        this.searchContent({
          query,
          includeShared: this.includeShared
        });
      } catch (error) {
        this.$notify({
          group: `alert`,
          title: `Something went wrong!`,
          text: `Sorry! We were unable to get the content.`,
          type: `error`
        });
      }
    }, 400),
    $route() {
      this.query = '';
    }
  },
  methods: mapActions(`content`, [`searchContent`])
};
</script>
